import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;
Pusher.logToConsole = false;

let echoInstance = null;

export function getEcho() {
    if (echoInstance) {
        return echoInstance;
    }

    const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;
    const reverbHost = import.meta.env.VITE_REVERB_HOST;
    const reverbPort = import.meta.env.VITE_REVERB_PORT;
    const reverbScheme = import.meta.env.VITE_REVERB_SCHEME;

    if (!reverbKey) {
        return null;
    }

    try {
        const isSecure = reverbScheme ? reverbScheme === 'https' : (typeof window !== 'undefined' && window.location.protocol === 'https:');
        const defaultPort = isSecure ? 443 : 80;
        const port = reverbPort ? parseInt(reverbPort, 10) : defaultPort;
        const host = (reverbHost && reverbHost !== 'localhost') ? reverbHost : (typeof window !== 'undefined' ? window.location.hostname : 'localhost');

        echoInstance = new Echo({
            broadcaster: 'reverb',
            key: reverbKey,
            wsHost: host,
            wsPort: port,
            wssPort: port,
            forceTLS: isSecure,
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
        });

        if (echoInstance?.connector?.pusher?.connection) {
            echoInstance.connector.pusher.connection.bind('error', () => {
                // Silently handle connection errors during offline/disconnect
            });
        }
        return echoInstance;
    } catch (e) {
        return null;
    }
}

window.Echo = new Proxy({}, {
    get(target, prop) {
        if (prop === 'isProxy') return true;
        const echo = getEcho();
        if (!echo) {
            return () => {};
        }
        const val = echo[prop];
        return typeof val === 'function' ? val.bind(echo) : val;
    }
});
